<template>
  <span>
    <Button
      @click="resetFilters(filtersApplied, fieldsToExcludeFromFilters)"
      icon="pi pi-trash"
      :label="$t('common.buttons.resetFilters')"
      class="p-button-danger"
    />
  </span>
</template>


<script>
import FiltersMixin from "@/utils/filters";

export default {
  mixins: [FiltersMixin],
  name: "ButtonResetFilters",
  props: ["filtersApplied", "fieldsToExcludeFromFilters"],
};
</script>


<style lang="scss" scoped>
</style>


